import React from "react";
import "./EnvironmentalAwarenessPage.css";
import Banner from "../Component/Environment.jpg"; // 🖼️ Replace with your actual banner image path

const EnvironmentalAwarenessPage = () => {
  return (
    <div className="environment-page">
      {/* ✅ Banner Section */}
      <div className="environment-banner">
        <img src={Banner} alt="Environmental Awareness at CPIT" className="banner-img" />
      </div>

      {/* ✅ Content Section */}
      <div className="environment-content">
        <h2>Environmental Awareness Program at CPIT</h2>
        <p>
          The <strong>Career Point of Information Technology (CPIT)</strong> is deeply committed to promoting
          environmental awareness and sustainability among students and society. With the growing threat
          of climate change and environmental degradation, CPIT works toward creating eco-conscious individuals
          who are dedicated to preserving our planet for future generations.
        </p>

        <h2>Objective of the Program</h2>
        <p>
          The main objective of the <strong>Environmental Awareness Program</strong> is to educate students
          and the local community about the importance of maintaining ecological balance and adopting sustainable
          lifestyles. Through various workshops, campaigns, and green initiatives, CPIT encourages responsible
          behavior toward nature, energy conservation, and pollution control.
        </p>

        <h2>Major Environmental Activities Conducted</h2>
        <ul>
          <li>🌳 <strong>Tree Plantation Drives</strong> — Regular plantation events in and around the campus to promote greenery.</li>
          <li>♻️ <strong>Waste Management Awareness</strong> — Sessions on recycling, waste segregation, and reusing resources.</li>
          <li>🚯 <strong>Clean Campus Campaign</strong> — “Swachh CPIT, Swachh Bharat” initiative to ensure a hygienic and eco-friendly environment.</li>
          <li>🌞 <strong>Energy Conservation Programs</strong> — Awareness campaigns on the use of renewable energy and electricity conservation.</li>
          <li>💧 <strong>Water Conservation Workshops</strong> — Demonstrations on rainwater harvesting and sustainable water usage.</li>
          <li>🌎 <strong>Environmental Seminars</strong> — Expert sessions on climate change, global warming, and biodiversity conservation.</li>
        </ul>

        <h2>Student Participation</h2>
        <p>
          Students of CPIT actively participate in these programs through volunteering, poster-making, debates,
          and awareness rallies. These initiatives not only enhance student engagement but also nurture leadership,
          responsibility, and teamwork.
        </p>

        <h2>Impact of the Program</h2>
        <p>
          CPIT’s continuous efforts toward environmental sustainability have inspired both students and the local
          community to adopt greener practices. The tree plantation and waste management drives have contributed
          to a cleaner and more eco-friendly campus environment.
        </p>

        <h2>Future Goals</h2>
        <p>
          CPIT aims to establish a dedicated <strong>Green Club</strong> to promote long-term environmental projects
          such as <strong>solar energy implementation, e-waste collection drives,</strong> and <strong>urban gardening.</strong>
          The institute also plans to collaborate with environmental NGOs for large-scale sustainability programs.
        </p>

        <h2>Conclusion</h2>
        <p>
          The <strong>Environmental Awareness Program</strong> organized by the <strong>Career Point of Information Technology (CPIT)</strong>
          reflects the institute’s strong commitment toward environmental responsibility and sustainable development.
          Through education and community involvement, CPIT continues to inspire positive change for a greener and healthier future.
        </p>
      </div>
    </div>
  );
};

export default EnvironmentalAwarenessPage;
